<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('listePaiementFactureAchat.titleForFactureAchat') }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <liste-paiement-facture-achat
      :referenceTable="referenceTable"
      :moduleDcf="constantes.MODULE"
    />
  </div>
</template>

<script>
import { MODULE_ACHAT } from '@/configuration/devisConf';
import { PAIEMENTS_FACTURES } from '@/configuration/achat/permissionsConf';
import { REFERENCE_TABLE_LISTE_PAIEMENTS_FACTURES } from '@/configuration/general/referenceTableConf';
import AppBreadcrumb from '@/components/general/breadcrumb';
import ListePaiementFactureAchat from '@/components/paiement/listePaiementFactureAchat';

export default {
  name: 'LPaiementsFactureAchat',
  components: {
    AppBreadcrumb,
    ListePaiementFactureAchat,
  },
  data() {
    return {
      perms: PAIEMENTS_FACTURES,
      referenceTable: REFERENCE_TABLE_LISTE_PAIEMENTS_FACTURES,
      constantes: {
        MODULE: MODULE_ACHAT,
      },
    };
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('listePaiementFactureAchat.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listePaiementFactureAchat.breadcrumb.listePaiementFactureAchat'), route: '', isActive: true },
      ];
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageAchat.paiements.liste'));
  },
};
</script>
